"use strict";

exports.__esModule = true;
exports["default"] = Pin;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Pin(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M426.665 170.075C425.81 75.8 348.624.095 254.349 1.008 160.13 1.889 84.425 79.049 85.338 173.266c.227 29.052 7.802 56.453 20.848 80.263h-.058L259.191 513l148.164-262.32h-.114c12.587-24.097 19.651-51.495 19.424-80.605m-83.11 83.967c-22.729 23.184-53.204 36.171-85.787 36.457h-1.082c-66.535 0-121.162-54.087-121.789-120.594-.286-32.525 12.075-63.231 34.862-86.414 22.842-23.242 53.262-36.116 85.787-36.457 67.673-.058 122.244 54.116 122.871 120.649.285 32.47-12.02 63.173-34.862 86.359m-86.587-54.971c-16.747.227-30.475-13.215-30.533-30.02-.283-16.805 13.218-30.475 29.965-30.589 16.747-.114 30.42 13.27 30.647 30.02.055 16.747-13.332 30.475-30.079 30.589"
  }));
}